import { render, staticRenderFns } from "./hot-tip.vue?vue&type=template&id=c836d456&scoped=true&"
import script from "./hot-tip.vue?vue&type=script&lang=js&"
export * from "./hot-tip.vue?vue&type=script&lang=js&"
import style0 from "./hot-tip.vue?vue&type=style&index=0&id=c836d456&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c836d456",
  null
  
)

export default component.exports